module.exports = __webpack_public_path__ + "static/img/part4.544b11d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/part4.png
// module id = m8lx
// module chunks = 0